// extracted by mini-css-extract-plugin
module.exports = {"VacationPeriod__title":"VacationPeriod_VacationPeriod__title__2Qw4M","VacationPeriod__titleText":"VacationPeriod_VacationPeriod__titleText__2Ceom"};